import type { Moment } from 'moment'
import { useSelector } from 'APP/Hooks/redux'

import Typography from 'APP/Converse/Typography'
import I18n, { isTranslationKey, type TranslationKey } from 'APP/I18n'
import { selectFamilyMembers } from 'APP/Store/Family/selectors'
import { selectBooking } from 'APP/Store/ProviderBooking/selectors'
import { getTimeframeUnit } from '../utils/helpers'

interface Props {
  messageKey: TranslationKey
  dateFrom: Moment
  dateUntil: Moment
}

export const TimeFrameMessage = ({ dateFrom, dateUntil, messageKey, ...rest }: Props) => {
  const timeframeUnit = getTimeframeUnit(dateUntil, dateFrom)
  const booking = useSelector(selectBooking)
  const familyMembers = useSelector(selectFamilyMembers)
  const isForDependent = Object.values(familyMembers ?? {}).some(
    (member) => member.type === 'child' && String(member.id) === String(booking?.member_id)
  )
  const dependentKey = `${messageKey}_dependent`
  const resolvedKey = isForDependent && isTranslationKey(dependentKey) ? dependentKey : messageKey
  const difference = dateUntil.diff(dateFrom, timeframeUnit)
  return (
    <Typography variant="bodyNormal" align="center" {...rest}>
      {I18n.t(resolvedKey, {
        difference,
        timeframe: I18n.t(`AppointmentBooking.timeframe_${timeframeUnit}`),
      })}
    </Typography>
  )
}
